/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Component, EventEmitter, Output, Input, TemplateRef } from '@angular/core';
import { SnackBarService } from 'app/shared/services/snack-bar.service';

@Component({
    selector: 'icon-action-button',
    templateUrl: './icon-action-button.component.html',
    styles: [`
  .icon-button {
    cursor: pointer;
  }
  `],
    standalone: false
})

// Simple bootstrap icon text button with some properties bound to inputs
// Uses font awesome icons and bootstrap outline syling
// When clicked the control emits an event with the name of the associated action
export class IconActionButtonComponent {
  @Input() enabled = true;
  @Input() actionEnabled = true;
  @Input() actionDisabledMessage = 'This action is not available';
  @Input() visible = true;
  @Input() iconName = 'ban'; // can be empty
  @Input() actionName = 'unknown';
  @Input() hoverText = 'unknown';
  @Input() buttonText: string; // can be empty
  @Input() class = ''; 
  @Input() popover = ''; 
  @Output() onInvokeAction = new EventEmitter<string>();

  get hoverTextDisplay(): string { return this.actionEnabled ? this.hoverText : '(not allowed) ' + this.hoverText; }

  constructor(public snackBar: SnackBarService) {}

  public invokeAction() {
    if(!this.visible) {
      return;
    }

    if (this.actionEnabled) {
      this.onInvokeAction.emit(this.actionName);
    } else {
      this.snackBar.info(this.actionDisabledMessage);
    }
  }

}
